module.exports = __webpack_public_path__ + "static/media/icon-warning-signal.88a9cf23.svg";